<template>
  <div class="campus-statistics">
    <div class="tuolele-main-box">
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择店铺</span>
          <div class="shop-select">
            <ShopSelect :init="init" @updateShop="updateShop" />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择时间</span>
          <el-date-picker
            v-model="filterObj.begin_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          />
          <i>至</i>
          <el-date-picker
            v-model="filterObj.end_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          />
          <b
            class="default-btn"
            :class="{ active: filterObj.search_calendar == '1' }"
            @click="selectDataForAccount"
          >
            只看周中工作日
          </b>
          <el-button type="primary" @click="searchData">查询</el-button>
        </div>
      </div>
    </div>
    <Tablist
      :list="tabList"
      :active-id="activeIndex"
      @updateCurrentPage="updateCurrentPage"
    />
    <div v-if="activeIndex == 0" class="dataTable1">
      <div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black data-title">
            销售总览
          </div>
          <div class="data-count">
            <div class="flex-wrap">
              <div class="flex-con">
                <div class="order-count">
                  <span>日均总学员人数</span>
                  <p class="bold">
                    {{
                      (
                        totalData.total_data1 / statisticsData.natural_days
                      ).toFixed(1)
                    }}
                  </p>
                </div>
              </div>
              <div class="flex-con">
                <div class="order-count">
                  <span>日均常规学员人数</span>
                  <p class="bold">
                    {{
                      (
                        totalData.total_data2 / statisticsData.natural_days
                      ).toFixed(1)
                    }}
                  </p>
                </div>
              </div>
              <div class="flex-con">
                <div class="order-count">
                  <span>日均到校人数</span>
                  <p class="bold">
                    {{
                      (
                        totalData.total_data4 / statisticsData.natural_days
                      ).toFixed(1)
                    }}
                  </p>
                </div>
              </div>
              <div class="flex-con">
                <div class="order-count">
                  <span>日均课耗人数</span>
                  <p class="bold">
                    {{
                      (
                        totalData.total_data5 / statisticsData.natural_days
                      ).toFixed(1)
                    }}
                  </p>
                </div>
              </div>
              <div class="flex-con">
                <div class="order-count">
                  <span>流失率</span>
                  <p class="bold">
                    {{
                      (
                        ((totalData.total_data6 * statisticsData.natural_days) /
                        totalData.total_data10) *
                        100
                      ).toFixed(2)
                    }}%
                  </p>
                </div>
              </div>
              <div class="flex-con">
                <div class="order-count">
                  <span>退费人数（流失）</span>
                  <p class="bold">
                    {{ totalData.total_data7 }}
                  </p>
                </div>
              </div>
              <div class="flex-con">
                <div class="order-count">
                  <span>结课人数</span>
                  <p class="bold">
                    {{ totalData.total_data8 }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black data-title">
            运营趋势<span
              style="font-size:16px !important"
            >（以下数据为所选时间段内包含的人工月数据）</span>
          </div>
          <DataLine
            :title="'日均总学员人数'"
            :echarts-data.sync="echartsData"
            :name="'total_data1'"
            :legend="'日均总学员人数'"
          />
          <DataLine
            :title="'日均到校人数'"
            :echarts-data.sync="echartsData"
            :name="'total_data4'"
            :legend="'日均到校人数'"
          />
          <DataLine
            :title="'日均课耗人数'"
            :echarts-data.sync="echartsData"
            :name="'total_data5'"
            :legend="'日均课耗人数'"
          />
          <DataLine
            unit="%"
            :title="'流失率'"
            :echarts-data.sync="echartsData"
            :name="'total_data6'"
            :legend="'流失率'"
          />
          <DataLine
            :title="'结课人数'"
            :echarts-data.sync="echartsData"
            :name="'total_data8'"
            :legend="'结课人数'"
          />
          <DataLine
            :title="'退费人数（流失）'"
            :echarts-data.sync="echartsData"
            :name="'total_data9,total_data7'"
            :legend="'退费人次,退费流失人数'"
          />
        </div>
      </div>
    </div>
    <div v-if="activeIndex == 1" class="dataTable1 tuolele-main-box">
      <div class="data-type-tab">
        <el-tabs v-model="activeName">
          <el-tab-pane label="全部数据" name="1">全部数据</el-tab-pane>
          <el-tab-pane label="学员数据" name="2">学员数据</el-tab-pane>
          <el-tab-pane label="课耗数据" name="3">课耗数据</el-tab-pane>
          <el-tab-pane label="到校数据" name="4">到校数据</el-tab-pane>
          <el-tab-pane label="带班数据" name="5">带班数据</el-tab-pane>
          <el-tab-pane label="流失数据" name="6">流失数据</el-tab-pane>
          <!-- <el-tab-pane label="总部监管数据" name="7">总部监管数据</el-tab-pane> -->
        </el-tabs>
      </div>
      <div class="data-type-content">
        <div v-show="activeName == '1'" class="table-box">
          <el-table :data="dataList" max-height="800px">
            <el-table-column
              prop="shop_name"
              label="店铺"
              width="150"
              fixed
            />
            <el-table-column label="学员统计">
              <el-table-column label="日均总学员">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data1 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <!-- student_data7 - student_data10 -->
              <el-table-column label="日均正式学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data7 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均体验学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data8 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均在读人数(含体验)">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data9 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均在读人数(不含体验)">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data10 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均新签学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data2 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均续费学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data3 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均仅有常规学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data4 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均仅有假期学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data5 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均连报学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data11 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均常规学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data12 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均假期学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data13 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="课耗统计">
              <el-table-column label="日均课耗人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption1 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均课耗金额">
                <template slot-scope="scope">
                  <span>￥{{
                    (
                      scope.row.class_consumption2 /
                      100 /
                      statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均消耗课耗">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption5 /
                      100 /
                      statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均退费课耗">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption6 /
                      100 /
                      statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="class_consumption1"
                label="累计课耗人数"
              />
              <el-table-column label="累计课耗金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.class_consumption2 / 100 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计消耗课耗">
                <template slot-scope="scope">
                  <span>{{ scope.row.class_consumption5 / 100 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计退费课耗">
                <template slot-scope="scope">
                  <span>{{ scope.row.class_consumption6 / 100 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均无课耗剩余天数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption8 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均预付课耗天数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption9 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均预付课耗金额">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption11 /
                      100 /
                      statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="到校统计">
              <el-table-column label="日均到校人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school1 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均到效率">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.arrive_school2"
                  >{{
                    (
                      (scope.row.arrive_school1 / scope.row.arrive_school2) *
                      100
                    ).toFixed(2)
                  }}%</span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column label="日均日报到校人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school3 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均月报到校人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school4 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均体验到校人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school5 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均正式体验课时到校">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school6 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计到校人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计日报到校人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school3 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计月报到校人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school4 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计体验到校人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school5 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计正式生体验课时到校">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school6 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均停课人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school7 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均未开课人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school8 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均日报未到人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school9 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="带班统计">
              <el-table-column prop="province" label="日小结统计">
                <el-table-column label="日均日小结发送数">
                  <template slot-scope="scope">
                    <span>{{
                      (
                        scope.row.class_data1 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均日小结发送率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.class_data2"
                    >{{
                      (
                        (scope.row.class_data1 / scope.row.class_data2) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均合格日小结数">
                  <template slot-scope="scope">
                    <span>{{
                      (
                        scope.row.class_data3 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均合格日小结率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.class_data1"
                    >{{
                      (
                        (scope.row.class_data3 / scope.row.class_data1) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="province" label="作业统计">
                <el-table-column label="日均作业单录入量">
                  <template slot-scope="scope">
                    <span>{{
                      (
                        scope.row.class_data5 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均作业单录入率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.class_data2"
                    >{{
                      (
                        (scope.row.class_data5 / scope.row.class_data2) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
            <el-table-column label="流失统计">
              <el-table-column prop="province" label="总计">
                <el-table-column label="流失率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.refund_data6"
                    >{{
                      (
                        ((scope.row.refund_data7 *
                        statisticsData.natural_days) /
                        scope.row.refund_data6) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="province" label="退费">
                <el-table-column label="退费总额">
                  <template slot-scope="scope">
                    <span>{{ (scope.row.refund_data1 / 100).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="refund_data2"
                  label="退费人数（流失）"
                />
                <el-table-column label="退费率（流失）">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.refund_data6"
                    >{{
                      (
                        ((scope.row.refund_data2 *
                        statisticsData.natural_days) /
                        scope.row.refund_data6) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="refund_data8"
                  label="退费人次"
                />
                <el-table-column label="退费人次率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.refund_data6"
                    >{{
                      (
                        ((scope.row.refund_data8 *
                        statisticsData.natural_days) /
                        scope.row.refund_data6) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均退费人数（流失）">
                  <template slot-scope="scope">
                    <span v-if="scope.row.refund_data6">{{
                      (
                        scope.row.refund_data2 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                    <span v-else>0.0</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均退费人次">
                  <template slot-scope="scope">
                    <span v-if="scope.row.refund_data6">{{
                      (
                        scope.row.refund_data8 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                    <span v-else>0.0</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="结课">
                <el-table-column
                  prop="refund_data4"
                  label="结课人数"
                />
                <el-table-column label="结课率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.refund_data6"
                    >{{
                      (
                        ((scope.row.refund_data4 *
                        statisticsData.natural_days) /
                        scope.row.refund_data6) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均结课人数">
                  <template slot-scope="scope">
                    <span v-if="scope.row.refund_data6">{{
                      (
                        scope.row.refund_data4 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                    <span v-else>0.0</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="province" label="转校">
                <el-table-column
                  prop="refund_data5"
                  label="总转校学生数"
                />
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="activeName == '2'" class="table-box">
          <el-table :data="dataList" max-height="800px">
            <el-table-column prop="shop_name" label="店铺" />
            <el-table-column label="学员统计">
              <el-table-column label="日均总学员">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data1 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <!-- student_data7 - student_data10 -->
              <el-table-column label="日均正式学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data7 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均体验学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data8 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均在读人数(含体验)">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data9 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均在读人数(不含体验)">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data10 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均新签学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data2 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均续费学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data3 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均仅有常规学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data4 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均仅有假期学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data5 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均连报学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data11 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均常规学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data12 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均假期学员人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.student_data13 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="activeName == '3'" class="table-box">
          <el-table :data="dataList" max-height="800px">
            <el-table-column prop="shop_name" label="店铺" />
            <el-table-column label="课耗统计">
              <el-table-column label="日均课耗人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption1 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均课耗金额">
                <template slot-scope="scope">
                  <span>￥{{
                    (
                      scope.row.class_consumption2 /
                      100 /
                      statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均消耗课耗">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption5 /
                      100 /
                      statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均退费课耗">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption6 /
                      100 /
                      statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="class_consumption1"
                label="累计课耗人数"
              />
              <el-table-column label="累计课耗金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.class_consumption2 / 100 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计消耗课耗">
                <template slot-scope="scope">
                  <span>{{ scope.row.class_consumption5 / 100 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计退费课耗">
                <template slot-scope="scope">
                  <span>{{ scope.row.class_consumption6 / 100 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均无课耗剩余天数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption8 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均预付课耗天数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption9 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均预付课耗金额">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.class_consumption11 /
                      100 /
                      statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="activeName == '4'" class="table-box">
          <el-table :data="dataList" max-height="800px">
            <el-table-column prop="shop_name" label="店铺" />
            <el-table-column label="到校统计">
              <el-table-column label="日均到校人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school1 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均到效率">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.arrive_school2"
                  >{{
                    (
                      (scope.row.arrive_school1 / scope.row.arrive_school2) *
                      100
                    ).toFixed(2)
                  }}%</span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column label="日均日报到校人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school3 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均月报到校人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school4 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均体验到校人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school5 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均正式体验课时到校">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school6 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计到校人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计日报到校人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school3 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计月报到校人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school4 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计体验到校人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school5 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计正式生体验课时到校">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrive_school6 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均停课人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school7 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均未开课人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school8 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均日报未到人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.arrive_school9 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="activeName == '5'" class="table-box">
          <el-table :data="dataList" max-height="800px">
            <el-table-column
              prop="shop_name"
              label="店铺"
              width="150"
              fixed
            />
            <el-table-column label="带班统计">
              <el-table-column prop="province" label="日小结统计">
                <el-table-column label="日均日小结发送数">
                  <template slot-scope="scope">
                    <span>{{
                      (
                        scope.row.class_data1 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均日小结发送率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.class_data2"
                    >{{
                      (
                        (scope.row.class_data1 / scope.row.class_data2) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均合格日小结数">
                  <template slot-scope="scope">
                    <span>{{
                      (
                        scope.row.class_data3 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均合格日小结率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.class_data1"
                    >{{
                      (
                        (scope.row.class_data3 / scope.row.class_data1) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="province" label="作业统计">
                <el-table-column label="日均作业单录入量">
                  <template slot-scope="scope">
                    <span>{{
                      (
                        scope.row.class_data5 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均作业单录入率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.class_data2"
                    >{{
                      (
                        (scope.row.class_data5 / scope.row.class_data2) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="activeName == '6'" class="table-box">
          <el-table :data="dataList" max-height="800px">
            <el-table-column
              prop="shop_name"
              label="店铺"
              width="150"
              fixed
            />
            <el-table-column label="流失统计">
              <el-table-column prop="province" label="总计">
                <el-table-column label="流失率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.refund_data6"
                    >{{
                      (
                        ((scope.row.refund_data7 *
                        statisticsData.natural_days) /
                        scope.row.refund_data6) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="province" label="退费">
                <el-table-column label="退费总额">
                  <template slot-scope="scope">
                    <span>{{ (scope.row.refund_data1 / 100).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="refund_data2"
                  label="退费人数（流失）"
                />
                <el-table-column label="退费率（流失）">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.refund_data6"
                    >{{
                      (
                        ((scope.row.refund_data2 *
                        statisticsData.natural_days) /
                        scope.row.refund_data6) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="refund_data8"
                  label="退费人次"
                />
                <el-table-column label="退费人次率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.refund_data6"
                    >{{
                      (
                        ((scope.row.refund_data8 *
                        statisticsData.natural_days) /
                        scope.row.refund_data6) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均退费人数（流失）">
                  <template slot-scope="scope">
                    <span v-if="scope.row.refund_data6">{{
                      (
                        scope.row.refund_data2 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                    <span v-else>0.0</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均退费人次">
                  <template slot-scope="scope">
                    <span v-if="scope.row.refund_data6">{{
                      (
                        scope.row.refund_data8 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                    <span v-else>0.0</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="结课">
                <el-table-column
                  prop="refund_data4"
                  label="结课人数"
                />
                <el-table-column label="结课率">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.refund_data6"
                    >{{
                      (
                        ((scope.row.refund_data4 *
                        statisticsData.natural_days) /
                        scope.row.refund_data6) *
                        100
                      ).toFixed(2)
                    }}%</span>
                    <span v-else>0.00%</span>
                  </template>
                </el-table-column>
                <el-table-column label="日均结课人数">
                  <template slot-scope="scope">
                    <span v-if="scope.row.refund_data6">{{
                      (
                        scope.row.refund_data4 / statisticsData.natural_days
                      ).toFixed(1)
                    }}</span>
                    <span v-else>0.0</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="province" label="转校">
                <el-table-column
                  prop="refund_data5"
                  label="总转校学生数"
                />
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div v-if="activeIndex == 2" class="dataTable1">
      <div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <HorizontalBar
            class="horizontal-bar"
            height="520"
            :title="'日均总学员人数'"
            :show-keys="barKeys1"
            :query-data.sync="dataInfo"
          />
          <HorizontalBar
            class="horizontal-bar"
            height="520"
            :title="'日均到校人数'"
            :show-keys="barKeys2"
            :query-data.sync="dataInfo"
          />
          <HorizontalBar
            class="horizontal-bar"
            height="520"
            :title="'日均课耗人数'"
            :show-keys="barKeys3"
            :query-data.sync="dataInfo"
          />
          <HorizontalBar
            unit="%"
            class="horizontal-bar"
            height="520"
            :title="'流失率'"
            :show-keys="barKeys4"
            :query-data.sync="dataInfo"
          />
          <HorizontalBar
            class="horizontal-bar"
            height="520"
            :title="'结课人数'"
            :show-keys="barKeys5"
            :query-data.sync="dataInfo"
          />
          <HorizontalBar
            class="horizontal-bar"
            height="520"
            :title="'退费人数（流失）'"
            :show-keys="barKeys6"
            :query-data.sync="dataInfo"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShopSelect from '@/components/toolbar/ShopSelect.vue'
import Tablist from '@/components/toolbar/Tablist.vue'
import DataLine from '@/components/chart/DataLine.vue'
import HorizontalBar from '@/components/chart/HorizontalBar.vue'
import Tool from '@/assets/js/tool.js'
export default {
  name: 'CampusStatistics',
  components: {
    ShopSelect,
    Tablist,
    DataLine,
    HorizontalBar
  },
  data() {
    return {
      filterObj: {
        begin_time: '',
        end_time: '',
        shop_id: '',
        search_calendar: '',
        key:
          'G1,G5,G6,G7,G8,G9,L2,L4,N4,M2,M4,H4,H5,H6,H9,I1,I2,I3,I4,I5,I6,J1,J2,J3,K2,K5,K6,N4,G1,G5,G6,G7,G8,G9,G13,G14,O2,O4,P1,K2'
      },
      selectDays: '0',
      tabList: [
        { id: '0', directory_name: '总览数据' },
        { id: '1', directory_name: '详细数据' },
        { id: '2', directory_name: '店铺对比数据' }
      ],
      activeIndex: '0',
      statisticsData: {},
      activeName: '1',
      init: true,
      dataInfo: [],
      echartsData: [],
      totalData: {},
      attrArr: [
        // 学员统计 按顺序排列
        { key: 'student_data1', attrs: 'G1+G5+G6' },
        { key: 'student_data2', attrs: 'G5' },
        { key: 'student_data3', attrs: 'G6' },
        { key: 'student_data4', attrs: 'G7' },
        { key: 'student_data5', attrs: 'G8' },
        { key: 'student_data6', attrs: 'G9' },
        { key: 'student_data7', attrs: 'G5+G6' },
        { key: 'student_data8', attrs: 'G1' },
        { key: 'student_data9', attrs: 'G13+G14' },
        { key: 'student_data10', attrs: 'G14' },
        { key: 'student_data11', attrs: 'G9' },
        { key: 'student_data12', attrs: 'G7' },
        { key: 'student_data13', attrs: 'G8' },
        // 课耗统计按顺序排列
        { key: 'class_consumption1', attrs: 'I1' },
        { key: 'class_consumption2', attrs: 'I2+I3' },
        { key: 'class_consumption5', attrs: 'I2' },
        { key: 'class_consumption6', attrs: 'I3' },
        { key: 'class_consumption8', attrs: 'I4' },
        { key: 'class_consumption9', attrs: 'I5' },
        { key: 'class_consumption11', attrs: 'I6' },
        // 到校统计按顺序排列
        { key: 'arrive_school1', attrs: 'H4+H5+H6' },
        { key: 'arrive_school2', attrs: 'G13+G14' },
        { key: 'arrive_school3', attrs: 'H4' },
        { key: 'arrive_school4', attrs: 'H5' },
        { key: 'arrive_school5', attrs: 'H6' },
        { key: 'arrive_school6', attrs: 'H9' },
        { key: 'arrive_school7', attrs: 'J1' },
        { key: 'arrive_school8', attrs: 'J2' },
        { key: 'arrive_school9', attrs: 'J3' },
        // 带班统计 按顺序排列
        { key: 'class_data1', attrs: 'N4' },
        { key: 'class_data2', attrs: 'H4+H5+H6' },
        { key: 'class_data3', attrs: 'O4' },
        { key: 'class_data4', attrs: 'N4' },
        { key: 'class_data5', attrs: 'O2' },
        // 退费统计 按顺序排列
        { key: 'refund_data1', attrs: 'L4+M4' },
        { key: 'refund_data2', attrs: 'K5+K6' },
        { key: 'refund_data4', attrs: 'K2' },
        { key: 'refund_data5', attrs: 'P1' },
        { key: 'refund_data6', attrs: 'G5+G6' }, // 计算流失率
        { key: 'refund_data7', attrs: 'K2+K5+K6' },
        { key: 'refund_data8', attrs: 'L2+M2' },
        // 总览统计和折线图使用
        { key: 'total_data1', attrs: 'G1+G5+G6' }, // 日均总学员人数
        { key: 'total_data2', attrs: 'G7' }, // 日均常规学员人数
        { key: 'total_data3', attrs: 'G8' }, // 日均假期学员人数
        { key: 'total_data4', attrs: 'H4+H5+H6' }, // 日均到校人数
        { key: 'total_data5', attrs: 'I1' }, // 日均课耗人数
        { key: 'total_data6', attrs: 'K2+K5+K6' }, // 流失率K2+K5+K6/G5+G6
        { key: 'total_data7', attrs: 'K5+K6' }, // 退费人数（流失）
        { key: 'total_data8', attrs: 'K2' }, // 结课人数
        { key: 'total_data9', attrs: 'L2+M2' }, // 退费人次
        { key: 'total_data10', attrs: 'G5+G6' } // 计算流失率
      ],
      barKeys1: [
        { key: 'total_data1', name: '日均总学员人数', color: '#4c84ff' }
      ],
      barKeys2: [
        { key: 'total_data4', name: '日均到校人数', color: '#4c84ff' }
      ],
      barKeys3: [
        { key: 'total_data5', name: '日均课耗人数', color: '#4c84ff' }
      ],
      barKeys4: [{ key: 'total_data6', name: '流失率', color: '#4c84ff' }],
      barKeys5: [{ key: 'total_data8', name: '结课人数', color: '#4c84ff' }],
      barKeys6: [
        { key: 'total_data9', name: '退费人次', color: '#4c84ff' },
        { key: 'total_data7', name: '退费人数（流失）', color: '#34c6ac' }
      ],
      dataList: [],
      artificial_days: 1,
      natural_days: 1
    }
  },
  mounted() {
    this.filterObj.begin_time = Tool.formatTime(
      new Date() - 86400 * 1000 * 30,
      'date'
    )
    this.filterObj.end_time = Tool.formatTime(new Date(), 'date')
  },
  methods: {
    getDataForShop() {
      this.$http.getDataForShop(this.filterObj).then(res => {
        if (res.code == 200) {
          this.statisticsData = res.data
          this.artificial_days = res.data.artificial_days
          this.natural_days = res.data.natural_days
          if (this.filterObj.search_calendar == 1) {
            this.statisticsData.natural_days = this.artificial_days
          } else {
            this.statisticsData.natural_days = this.natural_days
          }
          const dataInfo = res.data.shop_data
          let totalData = JSON.stringify(res.data.total_data)
          totalData = JSON.parse(totalData)
          dataInfo.unshift({
            shop_name: '总和',
            result: totalData
          })
          dataInfo.forEach(e => {
            Tool.formateData(this.attrArr, e)
            e.student_data4 = e.student_data4 - e.student_data6 // 学员统计仅含常规
            e.student_data5 = e.student_data5 - e.student_data6 // 学员统计仅含假期
            if (e.total_data10) {
              e.total_data6 = (
                ((e.total_data6 * this.statisticsData.natural_days) /
                  e.total_data10) *
                100
              ).toFixed(2) // 流失率
            } else {
              e.total_data6 = 0.0
            }
            e.total_data1 = (
              e.total_data1 / this.statisticsData.natural_days
            ).toFixed(1) // 日均总学员人数
            e.total_data4 = (
              e.total_data4 / this.statisticsData.natural_days
            ).toFixed(1) // 日均到校人数
            e.total_data5 = (
              e.total_data5 / this.statisticsData.natural_days
            ).toFixed(1) // 日均课耗人数
          })
          this.dataInfo = dataInfo.slice(1)
          this.dataList = dataInfo
          this.totalData = {
            result: res.data.total_data
          }
          Tool.formateData(this.attrArr, this.totalData)
        }
      })
      // 折线图
      this.$http.getDataForShopByDate(this.filterObj).then(res => {
        if (res.code == 200) {
          const echartsData = res.data
          echartsData.forEach(e => {
            e.result = e.value
            Tool.formateData(this.attrArr, e)
            if (this.filterObj.search_calendar == 1) {
              e.natural_days = e.artificial_days
            }
            if (e.total_data10) {
              e.total_data6 = (
                ((e.total_data6 * e.natural_days) / e.total_data10) *
                100
              ).toFixed(2) // 流失率
            } else {
              e.total_data6 = 0.0
            }
            e.total_data1 = (e.total_data1 / e.natural_days).toFixed(1) // 日均总学员人数
            e.total_data4 = (e.total_data4 / e.natural_days).toFixed(1) // 日均到校人数
            e.total_data5 = (e.total_data5 / e.natural_days).toFixed(1) // 日均课耗人数
          })
          this.echartsData = echartsData
        }
      })
    },
    updateCurrentPage(val) {
      this.activeIndex = val
    },
    updateShop(val) {
      this.filterObj.shop_id = val.join(',')
      if (this.init) {
        this.init = false
        this.getDataForShop(this.filterObj)
      }
    },
    searchData() {
      this.getDataForShop(this.filterObj)
    },
    selectDataForAccount() {
      this.filterObj.search_calendar =
        this.filterObj.search_calendar == '1' ? '' : '1'
    }
  }
}
</script>
<style lang="scss">
.campus-statistics {
  .form-row {
    .form-input {
      .el-button {
        width: 90px;
        height: 40px;
        margin-left: 20px;
      }
      > i {
        font-style: normal;
        margin: 0 10px;
      }
    }
  }
  .search-box {
    margin-top: 20px;
  }
  .el-form-item {
    display: block;
    .el-input {
      width: 150px;
      margin-left: 30px;
      margin-right: 20px;
    }
    .el-form-item__content {
      width: 90%;
    }
  }
  .date-box {
    display: inline;
  }
  .chart-body {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .data-title {
    display: block;
    width: 100%;
    font-size: 24px;
    margin-bottom: 30px;
  }
  .checkbox-item:first-child {
    width: 80px !important;
    margin-bottom: 20px;
  }
  .checkbox-item {
    width: 160px !important;
    margin-bottom: 20px;
  }
  .compare-data {
    margin-bottom: 50px;
    width: 760px;
    .title {
      color: black;
      font-size: 24px;
      margin-bottom: 20px;
    }
  }
  .flex-con {
    margin-right: 30px;
  }
  .flex-con:last-child {
    margin-right: 0;
  }
  .data-count {
    width: 100%;
  }
  .order-count {
    height: 160px;
    color: #fff;
    padding: 30px 0 0 15px;
    margin: 0 auto;
    background: url(../../assets/img/price-bg.png) #4c84ff right bottom
      no-repeat;
    background-size: 96px 117px;
    border-radius: 10px;
    span {
      font-size: 20px;
      margin-bottom: 25px;
    }
    p {
      font-size: 40px;
    }
  }
  .horizontal-bar {
    width: 760px;
  }
  .data-type-content {
    margin-bottom: 50px;
  }
  .default-btn {
    display: inline-block;
    width: 150px;
    height: 40px;
    margin-left: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-weight: normal;
    color: #999;
    border-radius: 6px;
    border: solid 1px #dcdfe6;
    cursor: pointer;
    &.active {
      border: solid 1px #4c84ff;
      color: #4c84ff;
    }
  }
  // .data-type-tab .el-tabs__item{
  //   background: #5b74ab;
  //   color: #adc6ff;
  // }
  // .data-type-tab .el-tabs__item.is-active{
  //   color: #fff;
  // }
  // .el-tabs__active-bar{
  //   background: #fff;
  // }
  .data-type-tab .el-tabs__header {
    margin: 0 0 40px;
  }
}
</style>
